export default __webpack_public_path__ + "static/media/AE11.37f1c1ac.jpg";